import { Form, Input, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import IDistrict from "../../models/districtModel";
import IProvince from "../../models/provinceModel";
import IShippingInfo from "../../models/shippingInfoModel";
import IWard from "../../models/wardModel";
import {
  addShippingInfo,
  selectProfile,
  selectUserInfo,
  setIsUpdattedAddress,
  updateUserInfo,
} from "../../redux/reducers/slice/profile";
import { getDistricts, getProvinces, getWards } from "../../services/common";

const AddressModal = (props: any) => {
  const { visible, closeModal } = props;
  const dispatch = useDispatch();
  const profileSlice = useSelector(selectProfile);
  const userInfo = useSelector(selectUserInfo);
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const [provinceOptions, setProvinceOptions] = useState<any>(null);

  const [districtOptions, setDistrictOptions] = useState<any>(null);

  const [wardOptions, setWardOptions] = useState<any>(null);

  useEffect(() => {
    getProvinces((cb) => {
      if (cb) {
        setProvinceOptions(cb);
      }
    });
  }, []);

  useEffect(() => {
    if (userInfo && userInfo.address) {
      if (userInfo.address.province_id) {
        getDistricts(userInfo.address.province_id, (cb) => {
          if (cb) {
            setDistrictOptions(cb);
          }
        });
      }
      if (userInfo.address.district_id) {
        getWards(userInfo.address.district_id, (cb) => {
          if (cb) {
            setWardOptions(cb);
          }
        });
      }

      form.setFieldsValue({
        street: userInfo.address.street,
        ward: userInfo.address.ward_id,
        district: userInfo.address.district_id,
        province: userInfo.address.province_id,
      });
    }
  }, [userInfo]);

  useEffect(() => {
    if (profileSlice.isUpdattedAddress) {
      const values = form.getFieldsValue();

      if (values && values.ward && values.district && values.province) {
        const wardCurrent = wardOptions.find(
          (v: IWard) => v.id === values.ward
        );
        const districtCurrent = districtOptions.find(
          (v: IDistrict) => v.id === values.district
        );
        const provinceCurrent = provinceOptions.find(
          (v: IProvince) => v.id === values.province
        );
        const info: IShippingInfo = {
          first_name: userInfo?.first_name || "",
          last_name: userInfo?.last_name || "",
          email: userInfo?.email || "",
          phone_number: userInfo?.phone_number || "",
          note: "",
          full_name_recevied: userInfo?.full_name || "",
          _id: "",
          address: {
            street: values.street,
            ward: {
              id: values.ward,
              name: wardCurrent.name,
              label: wardCurrent.displayName,
            },
            district: {
              id: values.district,
              name: districtCurrent.name,
              label: districtCurrent.displayName,
            },
            province: {
              id: values.province,
              name: provinceCurrent.name,
              label: provinceCurrent.displayName,
            },
          },
        };

        dispatch(addShippingInfo(info));
        dispatch(setIsUpdattedAddress(false));
      }
    }
  }, [profileSlice.isUpdatted]);

  const handelOnChangeProvince = (provinceId: any) => {
    // setProvince(provinceId);
    getDistricts(provinceId, (cb) => {
      if (cb) {
        setDistrictOptions(cb);
      }
    });
  };

  const handelOnChangeDistrict = (districtId: any) => {
    // setDistrict(districtId);
    getWards(districtId, (cb) => {
      if (cb) {
        setWardOptions(cb);
      }
    });
  };

  const handleSubmit = (values: any) => {
    const address = {
      street: values.street,
      ward: {
        id: values.ward,
        label: wardOptions.find((v: IWard) => v.id === values.ward).displayName,
      },
      district: {
        id: values.district,
        label: districtOptions.find((v: IDistrict) => v.id === values.district)
          .displayName,
      },
      province: {
        id: values.province,
        label: provinceOptions.find((v: IProvince) => v.id === values.province)
          .displayName,
      },
    };
    const entity = {
      //   ...initalValues,
      //   first_name: initalValues.firstName,
      //   last_name: initalValues.lastName,
      //   identity_number: initalValues.identityNumber,
      //   gender: initalValues.gender,
      //   birthday: new Date(initalValues.birthDay),
      //   email: initalValues.email,
      ...userInfo,
      gender: userInfo?.gender || 3,
      address,
    };

    dispatch(updateUserInfo(entity));
    dispatch(setIsUpdattedAddress(true));

    closeModal();
  };

  return (
    <>
      <Modal
        width={800}
        title="Địa chỉ"
        visible={visible}
        closable
        onCancel={closeModal}
        cancelText="Đóng"
        onOk={() => form.submit()}
        okText="Lưu">
        <Form
          form={form}
          className="kd-info-form-content center"
          size="large"
          name="profileForm"
          labelCol={{ span: 7 }}
          labelAlign="left"
          //   initialValues={initalValues || {}}
          onFinish={(values) => handleSubmit(values)}>
          <Form.Item
            className="kd-info-form-item"
            name="province"
            rules={[
              {
                required: true,
                message: t("customer_province_id_valid"),
              },
            ]}
            label={t("customer_province_id")}>
            <Select
              showSearch
              placeholder={t("customer_province_id_valid")}
              optionFilterProp="children"
              onChange={(value) => handelOnChangeProvince(value)}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {Array.isArray(provinceOptions) &&
                provinceOptions.length &&
                provinceOptions.map((item, i) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.displayName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="kd-info-form-item"
            name="district"
            rules={[
              {
                required: true,
                message: t("customer_district_id_valid"),
              },
            ]}
            label={t("customer_district_id")}>
            <Select
              showSearch
              placeholder={t("customer_district_id_valid")}
              optionFilterProp="children"
              onChange={(value) => handelOnChangeDistrict(value)}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {Array.isArray(districtOptions) &&
                districtOptions.length &&
                districtOptions.map((item, i) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.displayName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="kd-info-form-item"
            name="ward"
            rules={[
              {
                required: true,
                message: t("customer_ward_id_valid"),
              },
            ]}
            label={t("customer_ward_id")}>
            <Select
              showSearch
              placeholder={t("customer_ward_id_valid")}
              optionFilterProp="children"
              //   onChange={(value) => handelOnChangeProvince(value)}
              filterOption={(input, option) =>
                option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >=
                0
              }>
              {Array.isArray(wardOptions) &&
                wardOptions.length &&
                wardOptions.map((item, i) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.displayName}
                  </Select.Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item
            className="kd-info-form-item"
            name="street"
            rules={[
              {
                required: true,
                message: t("customer_address_valid"),
              },
            ]}
            label={t("customer_address")}>
            <Input
              className="input"
              placeholder={t("customer_address_placeholder")}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddressModal;
